import React from 'react';
import { createStackNavigator, StackNavigationOptions } from '@react-navigation/stack';
// Components
import { AdminWebLinksConfig } from '../modules/admin/adminRouter';
import { MySettingsWebLinksConfig } from '../modules/mySettings/mySettingRouter';
import { DemoWebLinksConfig } from '../modules/demo/demoRouter';
import { Home } from '../modules/home';
import { Event } from '../modules/event';
// Auth
import { Login, Logout, ForgetPassword, UserRegistration, RegistrationOtp } from '../modules/auth';
// Personal
import { MyEvents } from '../modules/myEvents';
import { MyFavorites } from '../modules/myFavorites';
import { MySettings } from '../modules/mySettings';
import { MyNotification } from '../modules/myNotification';
// Admin Portal
import { AdminPortal } from '../modules/admin';
// Demo
import { DemoPortal } from '../modules/demo';
// Search
import { SearchEvents } from '../modules/search';
// Checkout
import { CheckoutEvent } from '../modules/checkout';
// Checkout Voucher
import { CheckoutVoucher } from '../modules/voucher';
// Event Details Management
// import { AdminEventDetailsManagement } from '../modules/admin/events';
// Change Password
import { MySettingChangePassword } from '../modules/mySettings/profile/changePassword';

const HomeStack = createStackNavigator();

// First level menu
export const AppLinksConfig = {
  home: 'home',
  event: 'event',
  'event-registration': 'event-registration',
  login: 'login',
  'my-events': 'my-events',
  'my-favorites': 'my-favorites',
  'admin-portal': {
    path: 'admin-portal',
    screens: AdminWebLinksConfig,
  },
  'my-settings': {
    path: 'my-settings',
    screens: MySettingsWebLinksConfig,
  },
  demo: {
    path: 'demo',
    screens: DemoWebLinksConfig,
  },
  checkout: 'checkout',
  search: 'search',
  voucher: 'voucher',
  eventManagementDetails: 'eventManagementDetails',
  otpValidation: 'otpValidation',
  changePassword: 'changePassword',
};

export const AppRoutes = () => (
  <HomeStack.Navigator
    screenOptions={{
      headerShown: false,
      cardStyle: {
        flex: 1,
      },
    }}
  >
    <HomeStack.Screen name="home" component={Home} options={{ title: `${process.env.REACT_APP_TITLE} - Home` }} />
    {/* Login/Auth */}
    <HomeStack.Screen name="login" component={Login} options={{ title: `${process.env.REACT_APP_TITLE} - Login` }} />
    <HomeStack.Screen name="logout" component={Logout} options={{ title: `${process.env.REACT_APP_TITLE} - Logout` }} />
    <HomeStack.Screen
      name="forgot-password"
      component={ForgetPassword}
      options={{ title: `${process.env.REACT_APP_TITLE} - Forgot Password` }}
    />
    <HomeStack.Screen
      name="register"
      component={UserRegistration}
      options={{ title: `${process.env.REACT_APP_TITLE} - User Registration` }}
    />
    {/* User/Profile */}
    <HomeStack.Screen
      name="event"
      component={Event}
      options={
        { title: `${process.env.REACT_APP_TITLE} - Event Details`, unmountOnBlur: true } as StackNavigationOptions
      }
    />
    <HomeStack.Screen
      name="my-events"
      component={MyEvents}
      options={{ title: `${process.env.REACT_APP_TITLE} - My Events`, unmountOnBlur: true } as StackNavigationOptions}
    />
    <HomeStack.Screen
      name="my-favorites"
      component={MyFavorites}
      options={
        { title: `${process.env.REACT_APP_TITLE} - My Favorites`, unmountOnBlur: true } as StackNavigationOptions
      }
    />
    <HomeStack.Screen
      name="my-notification"
      component={MyNotification}
      options={
        { title: `${process.env.REACT_APP_TITLE} - Notification`, unmountOnBlur: true } as StackNavigationOptions
      }
    />
    {/* Admin Portal -- route set in /components/mySetting/mySetting-router */}
    <HomeStack.Screen
      name="my-settings"
      component={MySettings}
      options={{ title: `${process.env.REACT_APP_TITLE} - My Settings` }}
    />
    {/* Admin Portal -- route set in /components/admin/admin-router */}
    <HomeStack.Screen
      name="admin-portal"
      component={AdminPortal}
      options={{ title: `${process.env.REACT_APP_TITLE} - Admin Portal` }}
    />
    {/* Demo Portal -- route set in /components/demo/demo-router */}
    <HomeStack.Screen name="demo" component={DemoPortal} options={{ title: 'Demo Portal' }} />

    <HomeStack.Screen name="search" component={SearchEvents} options={{ title: 'Search' }} />

    <HomeStack.Screen name="checkout" component={CheckoutEvent} options={{ title: 'Checkout' }} />

    <HomeStack.Screen name="voucher" component={CheckoutVoucher} options={{ title: 'Voucher' }} />

    {/* <HomeStack.Screen name="event-details-managment" component={AdminEventDetailsManagement} options={{ title: 'Event Details' }} /> */}

    <HomeStack.Screen
      name="otpValidation"
      component={RegistrationOtp}
      options={{ title: `${process.env.REACT_APP_TITLE} - OTP` }}
    />

    <HomeStack.Screen
      name="changePassword"
      component={MySettingChangePassword}
      options={{ title: `${process.env.REACT_APP_TITLE} - Change Password` }}
    />
  </HomeStack.Navigator>
);

/*@react-navigation/bottom-tabs
@react-navigation/core
@react-navigation/devtools
@react-navigation/drawer
@react-navigation/elements
@react-navigation/material-top-tabs
@react-navigation/native-stack
@react-navigation/native
@react-navigation/routers
@react-navigation/stack
react-native-tab-view
*/
